import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';

const showLanguagePopup = props => {
  const { open = false, labelHead = '', listItem } = props;
  return (
    <div>
      <Dialog
        open={open}
        aria-labelledby="dialog-title"
        PaperProps={{
          style: {
            marginLeft: '22px',
            marginRight: '22px',
            width: '28.125em',
            background: '#f6f6f6 0% 0% no-repeat padding-box',
            boxShadow: '16px 0px 24px #00000029',
            borderRadius: '0.625em'
          }
        }}
      >
        {labelHead()}
        <DialogContent css={{
          paddingLeft: '1rem',
          paddingRight: '1rem',
          width: '300px',
          wordBreak: 'break-word'
        }}
        >
          <DialogContentText css={{
            fontFamily: 'jioType-Medium',
            fontSize: '14px',
            color: '#000000',
            marginTop: '-10px'
          }}
          >
            {listItem()}
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default showLanguagePopup;
